import {
  DailyAuditData,
  LogReportData,
  SuccceedFailedData,
} from "../types/LogReport";
import { ParamData } from "../types/Param";
import { clientApiUrl } from "./api";

const API_URL = "/LogReports";

export const getLoginCount = async (
  param: ParamData
): Promise<LogReportData[]> => {
  try {
    const res = await clientApiUrl.get<LogReportData[]>(
      `${API_URL}/logins-count`,
      {
        params: {
          startingFrom: param.startingFrom,
          endingOn: param.endingOn,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all logins count error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getSucceededFailedLoginsCount = async (
  param: ParamData
): Promise<SuccceedFailedData[]> => {
  try {
    const res = await clientApiUrl.get<SuccceedFailedData[]>(
      `${API_URL}/succeeded-failed-logins`,
      {
        params: {
          startingFrom: param.startingFrom,
          endingOn: param.endingOn,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all logins count error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getDailyAuditCount = async (
  param: ParamData
): Promise<DailyAuditData> => {
  try {
    const res = await clientApiUrl.get<DailyAuditData>(
      `${API_URL}/daily-audit`,
      {
        params: {
          entity: param.entity,
          startingFrom: param.startingFrom,
          endingOn: param.endingOn,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all logins count error: ${
        error.response?.data?.message || error.message
      }`
    );
    return {
      created: 0,
      updated: 0,
      deleted: 0,
    };
  }
};
